import keyBy from 'lodash/keyBy';

import {
  REQUEST_BANK,
  REQUEST_BANK_SUCCESS,
  REQUEST_BANK_FAILURE,
  SET_BANK_BRANCHES,
  REQUEST_BANK_BRANCHES,
  SET_ACCOUNT_STATUS,
  REQUEST_BANK_UPDATE,
  REQUEST_BANK_UPDATE_SUCCESS,
  REQUEST_BANK_UPDATE_FAILURE,
  CREATE_NEW_ACCOUNT,
  CLEAR_NEW_ACCOUNT,
} from '../constants/ActionTypes';

const initialState = {
  loaded: true,
  branchesLoaded: false,
  error: null,
  hasError: false,
  accounts: {},
  payYear: 0,
  bankBranches: [],
  bankLedgers: {
    '05': '05',
    '04': '04',
    13: '13',
    14: '14',
    15: '15',
    18: '18',
    24: '24',
    26: '26',
    29: '29',
    38: '38',
  },
};
export default function EmployeeBankReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_BANK: {
      return {
        ...state,
        loaded: false,
        hasError: false,
        error: null,
      };
    }
    case REQUEST_BANK_SUCCESS: {
      const accounts = keyBy(action.accounts, 'EmployeeMasterBankID');
      return {
        ...state,
        loaded: true,
        accounts,
      };
    }
    case REQUEST_BANK_FAILURE:
      return {
        ...state,
        loaded: true,
        error: action.error,
        hasError: true,
      };
    case SET_ACCOUNT_STATUS:
      return {
        ...state,
        [`status-${action.status.id}`]: action.status.value,
      };
    case REQUEST_BANK_BRANCHES:
      return {
        ...state,
        branchesLoaded: false,
      };
    case SET_BANK_BRANCHES:
      return {
        ...state,
        branchesLoaded: true,
        bankBranches: keyBy(action.branches, 'SysBankBranchID'),
      };
    case REQUEST_BANK_UPDATE: {
      return {
        ...state,
        hasError: false,
        error: null,
      };
    }
    case REQUEST_BANK_UPDATE_SUCCESS: {
      return {
        ...state,
        hasError: false,
        error: null,
        [`status-${action.account.EmployeeMasterBankID}`]: 'ACCOUNT_FIXED',
        accounts: {
          ...state.accounts,
          [action.account.EmployeeMasterBankID]: action.account,
        },
      };
    }
    case REQUEST_BANK_UPDATE_FAILURE: {
      return {
        ...state,
        error: action.error,
        hasError: true,
      };
    }
    case CREATE_NEW_ACCOUNT:
      return {
        ...state,
        'status-NEW_ACCOUNT': 'ACCOUNT_EDIT',
        accounts: {
          ...state.accounts,
          NEW_ACCOUNT: { EmployeeMasterBankID: 'NEW_ACCOUNT' },
        },
      };
    case CLEAR_NEW_ACCOUNT: {
      const accounts = state.accounts;
      delete accounts.NEW_ACCOUNT;
      return {
        ...state,
        'status-NEW_ACCOUNT': null,
        accounts,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/EmployeeBankReducer.js